<template>
  <div class="app">
    <NavBar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Footer from "./components/Footer.vue";
import NavBar from "./components/NavBar.vue";
import {setOptions} from "@googlemaps/js-api-loader";


export default {

  name: "App",
  components: {
    NavBar,
    Footer,
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
}
body {
  background-color: #fffbf3;
}
.container {
  padding: 0 20px;
  max-width: 1440px;
  margin: 0 auto;
}
</style>
